
import React from "react";
import { useState } from 'react';
import pageData from "../PageData";
const PageNotFound =()=>{ 

//const [imgUrl,setImageUrl] = useState("/assets/images/usersImage/28.jpg");
//const [userName, setUserName] = useState("Naveen"); 
return (
 <>
 {`404 Page Not Found`}
		</>

);
}
export default PageNotFound;